import { render, staticRenderFns } from "./AssignmentRuleSentenceBuilder.vue?vue&type=template&id=a02b1a52&scoped=true&"
import script from "./AssignmentRuleSentenceBuilder.vue?vue&type=script&lang=js&"
export * from "./AssignmentRuleSentenceBuilder.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentRuleSentenceBuilder.vue?vue&type=style&index=0&id=a02b1a52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a02b1a52",
  null
  
)

export default component.exports